import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import helper from "../../utils/helpers";
import { isEmpty } from "lodash";
import TableHeaderCell from "components/reusable/TableHeaderCell";
import { FiTrash2 } from "react-icons/fi"; // Add this import
import useToastContext from "hooks/useToastContext";
import { apiDelete } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";

const BioMetricTable = ({ employeeList, onDeleteSuccess }) => {
  const { t } = useTranslation();
  const notification = useToastContext();

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      try {
        const result = await apiDelete(`${apiPath.deleteTimeSheet}/${id}`);
        if (result?.data?.success) {
          notification.success(result?.data?.message || "Record deleted successfully");
          if (onDeleteSuccess) {
            onDeleteSuccess();
          }
        } else {
          notification.error(result?.data?.message || "Failed to delete record");
        }
      } catch (error) {
        console.error("Error deleting record:", error);
        notification.error("Error deleting record");
      }
    }
  };

  return (
    <div>
      <div className="p-3">
        <div className="overflow-x-auto relative rounded-lg border">
          <table className="w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400 ">
            <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <TableHeaderCell text={t("DATE")} />
                <TableHeaderCell text={t("EMPLOYEE_NAME")} />
                <TableHeaderCell text={t("EMPLOYEE_ID")} />
                <TableHeaderCell text={t("PUNCH_IN_TIME")} />
                <th scope="col" className="py-3 px-6 cursor-pointer">
                  <div className="flex justify-start">
                    <span>{t("PUNCH_IN_LOCATION")}</span>
                  </div>
                </th>
                <TableHeaderCell text={t("PUNCH_OUT_TIME")} />
                <th scope="col" className="py-3 px-6 cursor-pointer">
                  <div className="flex justify-start">
                    <span>{t("PUNCH_OUT_LOCATION")}</span>
                  </div>
                </th>
                <th scope="col" className="py-3 px-6 text-center">
                  {t("TOTAL_BREAK_TIME")}
                </th>
                <th scope="col" className="py-3 px-6 text-center">
                  {t("WORKING_HOURS")}
                </th>
                {/* Add Actions column */}
                <th scope="col" className="py-3 px-6 text-center">
                  {t("ACTIONS")}
                </th>
              </tr>
            </thead>
            <tbody>
              {employeeList &&
                employeeList.map((item, i) => {
                  return (
                    <tr key={i} className="dark:bg-gray-800 bg-white border-b dark:border-gray-700">
                      <td className="py-4 px-6 text-gray-900 border-r">{dayjs(item?.punchInDateTime).format("MM-DD-YYYY")}</td>
                      <td className="text-gray-900 py-4 px-6 border-r">{item?.employee?.name}</td>
                      <td className="px-6 border-r py-4 text-gray-900">{item?.employee?.employeeId}</td>
                      <td className="py-4 border-r text-gray-900 px-6">{item?.punchInDateTime ? dayjs(item?.punchInDateTime).format("h:mm:ss A") : "N/A"}</td>
                      <td className="border-r py-4 px-6 text-gray-900">{item?.punchInLocation || "N/A"}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.punchOutDateTime ? dayjs(item?.punchOutDateTime).format("h:mm:ss A") : "N/A"}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.punchOutLocation || "N/A"}</td>
                      <td className="py-4 px-6 border-r text-left text-gray-900">{helper.calculateTotalBreakTime(item?.breaks, item?.endBreak)}</td>
                      <td className="py-4 px-6 border-r text-gray-900">
                        {helper.calculateTotalWorkTime({
                          punchInDateTime: item?.punchInDateTime,
                          punchOutDateTime: item?.punchOutDateTime,
                          breakEndTime: item?.endBreak,
                          breakTime: item?.breaks,
                        })}
                      </td>
                      {/* Add delete button */}
                      <td className="py-4 px-6 border-r text-center">
                        <button
                          onClick={() => handleDelete(item._id)}
                          className="text-red-500 hover:text-red-700 transition-colors"
                          title="Delete"
                        >
                          <FiTrash2 size={18} />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              {isEmpty(employeeList) ? (
                <tr className="dark:bg-gray-800 bg-white border-b text-center dark:border-gray-700">
                  <td className="colSpan={11} px-6 border-r py-4">{t("O_NO_RECORD_FOUND")}</td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default BioMetricTable;